import { OTHER } from "@/components/pano/PanoQuestion";

// Mirrors backend routes/pano_audit.py so crews see what's missing offline too.
export const skippedSections = (form, answers) => {
  const out = new Set();
  (form?.skip_rules || []).forEach((r) => {
    if (answers[r.entry]?.value === r.equals) r.skip_sections.forEach((s) => out.add(s));
  });
  return out;
};

export const isAnswered = (q, a) => {
  if (!a) return false;
  const v = a.value;
  const otherOk = !!(a.other || "").trim();
  if (q.type === "checkbox") {
    const vals = v || [];
    return vals.some((x) => x !== OTHER) || (vals.includes(OTHER) && otherOk);
  }
  if (v === OTHER) return otherOk;
  return !!String(v ?? "").trim();
};

export const missingRequired = (form, answers) => {
  const skip = skippedSections(form, answers);
  return (form?.sections || [])
    .filter((s) => !skip.has(s.id))
    .flatMap((s) => s.questions.filter((q) => q.required && !isAnswered(q, answers[q.entry])).map((q) => ({ section: s.title, q })));
};

const answerText = (q, a) => {
  const v = a?.value;
  const other = (a?.other || "").trim();
  if (Array.isArray(v)) return [...v.filter((x) => x !== OTHER), ...(v.includes(OTHER) && other ? [`Other: ${other}`] : [])].join(", ");
  if (v === OTHER) return `Other: ${other}`;
  return String(v ?? "");
};

// Plain-text summary for pasting into Pano's Google Form by hand.
export const summaryText = (form, answers, project) => {
  const skip = skippedSections(form, answers);
  const lines = [`${form.title.replace(" - Google Form", "")} — ${project.site_name || ""} (${project.site_number || ""})`, ""];
  form.sections.filter((s) => !skip.has(s.id)).forEach((s) => {
    lines.push(`== ${s.title} ==`);
    s.questions.forEach((q) => lines.push(`${q.title}\n  ${answerText(q, answers[q.entry]) || "—"}`));
    lines.push("");
  });
  return lines.join("\n");
};
